import { render } from "./LegacyInvoicesList.vue?vue&type=template&id=670bb9bc&scoped=true"
import script from "./LegacyInvoicesList.vue?vue&type=script&lang=js"
export * from "./LegacyInvoicesList.vue?vue&type=script&lang=js"

import "./LegacyInvoicesList.vue?vue&type=style&index=0&id=670bb9bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670bb9bc"]])

export default __exports__